/*
 * Copyright (c) 2021 OCLC, Inc. All Rights Reserved.
 *
 * OCLC proprietary information: the enclosed materials contain proprietary information of OCLC Online Computer
 * Library Center, Inc. and shall not be disclosed in whole or in any part to any third party or used by any person
 * for any purpose, without written consent of OCLC, Inc.  Duplication of any portion of these materials shall include
 * this notice.
 */
import React, { useEffect } from 'react'
import { PropTypes } from 'prop-types'
import { CssBaseline } from '@material-ui/core'
import { ThemeProvider } from '@material-ui/styles'
import { customizeTheme } from '../src/theme'

/**
 * Custom theme provider with institution styling.
 * @param {Object} props - props
 * @returns {Node} - A React node
 */
function CustomThemeProvider(props) {
  // Can check i18n for right to left, rtl, languages
  const direction = 'ltr'

  useEffect(() => {
    document.body.dir = direction
  }, [direction])

  return (
    <ThemeProvider theme={customizeTheme(direction)}>
      <CssBaseline />
      {props.children}
    </ThemeProvider>
  )
}

CustomThemeProvider.propTypes = {
  children: PropTypes.node,
}

export default CustomThemeProvider
